import { useState } from "react";
import Checkbox from "../components/Checkbox";
import { store } from "../stores/Store";
import { Modal } from "../components/Modal";
import { observer } from "mobx-react-lite";
import { Button } from "../components/Button";
import Input from "../components/Input";
import ErrorIcon from "../icons/ErrorIcon";
import { publicUrl } from "../utils/url";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/navigation';
import './SliderModal.scss';
import { BREAKPOINT_MD } from "../stores/constants";
import InfoBar from "../components/InfoBar";
import CarIcon from "../icons/CarIcon";
import { _t } from '../utils/Lang';


const MattressDetailModal = observer(() => {
    const breakpoints = {
        [BREAKPOINT_MD]: {
            slidesPerView: 2,
            spaceBetween: 20,
        },
    };
    console.log({ breakpoints });
    return (
        <Modal
            className="MattressDetailModal modal-lg"
            onClose={e => {
                store.closeMattressDetailsPopup();
            }}
            isOpen={store.isMattressDetailsOpen}

        >

            <InfoBar icon={<CarIcon />} className="a-start mb-0 mt-6 InfoBar--lightgray">
                <div className="row a-center">
                    <div className="col-12 py-1">
                        <span dangerouslySetInnerHTML={{ __html: _t('mattress_info_question') }} />
                    </div>


                </div>

            </InfoBar>
            <div className="SliderModal MattressDetailModal mt-4">
                <Swiper
                    modules={[Navigation]}
                    slidesPerView={1}
                    spaceBetween={20}
                    navigation={{
                        nextEl: '.SliderModal__swiper-button-next',
                        prevEl: '.SliderModal__swiper-button-prev',
                    }}
                    breakpoints={breakpoints}
                >
                    <SwiperSlide className="SliderModal__slide">
                        <div className="SliderModal__image"></div>
                        <div className="SliderModal__text">
                            <h1>{_t('mattress_default_name')}</h1>
                            <h2>
                                {_t('mattress_learn_more')}
                            </h2>
                        </div>
                    </SwiperSlide>
                    <SwiperSlide className="SliderModal__slide">
                        <div className="SliderModal__image"></div>
                        <div className="SliderModal__text">
                            <p>Booth poutine hammock microdosing keytar. Tattooed food level coloring mlkshk listicle. Booth ethical flannel LaCroix carry pin disrupt scenester. Four it rights bo.</p>
                        </div>
                    </SwiperSlide>
                    <SwiperSlide className="SliderModal__slide">
                        <div className="SliderModal__image"></div>
                        <div className="SliderModal__text">
                            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Dignissimos earum natus vitae exercitationem, similique unde. Quae beatae dolorum, voluptatibus sint consectetur quisquam eos necessitatibus dolorem in saepe? Magni, possimus error?</p>
                        </div>
                    </SwiperSlide>
                </Swiper>
                <div className="d-flex g-2 p-2 j-end w-100">
                    <button className=" SliderModal__swiper-button-prev">
                        <svg width="9" height="15" viewBox="0 0 9 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M2.34367 7.22699L8.25391 13.1372L7.34456 14.0466L0.524982 7.22699L7.34456 0.407405L8.25391 1.31675L2.34367 7.22699Z" fill="#1F1F1F" />
                        </svg>

                    </button>
                    <button className=" SliderModal__swiper-button-next">
                        <svg width="9" height="15" viewBox="0 0 9 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M6.65633 7.77301L0.746094 1.86277L1.65544 0.95343L8.47502 7.77301L1.65544 14.5926L0.746094 13.6833L6.65633 7.77301Z" fill="#1F1F1F" />
                        </svg>

                    </button>
                </div>

                <InfoBar className="mb-0">
                    <div className="row a-center">
                        <div className="col-12 col-md-8 mb-2 mb-md-0">
                            <span dangerouslySetInnerHTML={{ __html: _t('mattress_info_question') }} />
                        </div>
                        <div className="col-12 col-md-4">
                            <Button onClick={() => {
                                // alert('Quiz');
                            }} className="btn-sm hollow w-100 primary">{_t('mattress_read_more')}</Button>
                        </div>
                    </div>

                </InfoBar>

            </div>


        </Modal>
    )
});

export default MattressDetailModal